import GeneralFormFields, { FormFieldActions, RequestStatus } from "components/GeneralFormView/types";
import { FormFieldsBuilder } from "components/GeneralFormView/Utils/FormFieldsBuilder";
import { FacilityFormViewModel } from "./staticTextFormViewModel";
import React from 'react';
import GeneralFormView from "components/GeneralFormView";
import { useObserver } from "mobx-react";
import { FacilityDTO } from "./staticTextDTO";
import { stores } from "mobx-store";
import Condition, { ConditionalStatementTypes, ConditionExpression, ConditionStatement } from "components/GeneralFormView/Utils/Condition";
import { facilityToDTO } from "./staticText.mapper";
import SnackBarComponent from "components/SnackBarComponent/SnackBarComponent";
import { STATIC_TEXT_APP } from "mobx-store/storeInterfaces/staticTextInterface";
import { useParams } from "react-router";

const AddEditStaticText: React.FC = () => {
  const { app, id: key } = useParams<{app: STATIC_TEXT_APP, id: string}>();
  const {
    formFields,
  } = new FormFieldsBuilder<FacilityFormViewModel>()
    .addField('key', {
      fieldOptions: {
      },
      hasTranslations: true,
      title: 'Text Key',
      type: GeneralFormFields.INPUT_FIELD,
      condition: (values, actions, location) => new Condition({
        values,
        initialStatement: new ConditionStatement({
          action: actions[FormFieldActions.DISABLE],
          type: ConditionalStatementTypes.IF,
          expression: new ConditionExpression({
            values,
            expression: () => !!key
          }),
        }),
      }),
    })
    .addField('description', {
      fieldOptions: {
      },
      hasTranslations: true,
      title: 'Text Description',
      type: GeneralFormFields.INPUT_FIELD,
    })
    .addField('category', {
      fieldOptions: {
      },
      hasTranslations: true,
      title: 'Text Category',
      type: GeneralFormFields.INPUT_FIELD,
    })
    .addField('value', {
      fieldOptions: {
      },
      hasTranslations: true,
      title: 'Text Value',
      type: GeneralFormFields.INPUT_FIELD,
    });


  return useObserver(() => (
    <GeneralFormView<FacilityDTO, FacilityFormViewModel>
      defaultLang="ar"
      title="Static text"
      identifier="key"
      otherLanguages={[
        'en'
      ]}
      formData={formFields}
      create={async (formValue) => {
        try {
          const toDto = facilityToDTO(Object.create({
            ...formValue,
            app,
          }));
          const res = await stores.staticTextStore.createStaticText(toDto as any, 'ar')
          return formValue.key;
        } catch (error) {
          SnackBarComponent.getInstance().openSnackbar((error as any).response.data.message, 3000, 'error');
          throw error;
        }
          
      }}
      update={async (id, formValue, language) => {
        try {
          const toDto = facilityToDTO(Object.create(formValue));
          await stores.staticTextStore.updateStaticText(toDto, id, app, language);
        } catch (error) {
          SnackBarComponent.getInstance().openSnackbar((error as any).response.data.message, 3000, 'error');
        }
      }}
      get={async (id, language) => {
        await stores.staticTextStore.getStaticTextByKey(id, app ,language);
        return new FacilityFormViewModel(stores.staticTextStore.selectedStaticText as any);
      }}
      isFetchSuccessful={stores.staticTextStore.getStaticTextRequestStatus === RequestStatus.SUCCESS}
      createOrUpdateStatus={stores.staticTextStore.addEditLoadingState}
    />
  ));
};

export default AddEditStaticText;


